import { useNavigate, useLocation } from 'react-router-dom';
import { ForgotPasswordPage } from '@practium/features/auth';

export const ForgotPasswordPageAdmin = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const email = (location.state as { email?: string } | null)?.email ?? '';

	return (
		<ForgotPasswordPage
			userEmail={email}
			onBack={() => navigate(-1)}
		/>
	);
};
